import { useQuery } from '@tanstack/react-query';

import useAppInit from '@/hooks/domain/App/useAppInit';
import service from '@/services/index';
import useWorkspaceStore from '@/stores/WorkspaceStore';

const useChartListQuery = () => {
  const wa = useWorkspaceStore((state) => state.currWorkspace)?.alias;
  const appInit = useAppInit();
  return useQuery({
    queryKey: ['chart-list'],
    queryFn: service.chart.fetchChartList,
    enabled: appInit && !!wa,
    staleTime: 1000 * 60 * 5,
  });
};

export { useChartListQuery };
